import { addBoundsToItem } from "./findBoundsOfItem";
import { encapsulateItems, unEncapsulateItems, isEncapsulated } from "../miro/miroEncapsulator";

export function sortLeftRightTopBottom(items) {
  if (!items) {
    return [];
  }
  if (items.length === 0) {
    return items;
  }
  if (items.length > 0) {
    const wasEncapsulated = isEncapsulated(items);
    let encapsulatedItems = encapsulateItems(items);
    let boundsAddedItems = encapsulatedItems.map((item) => addBoundsToItem(item));
    boundsAddedItems.sort(function compareLeft(a, b) {
      if (a.bounds.left < b.bounds.left) {
        return -1;
      }
      if (a.bounds.left > b.bounds.left) {
        return 1;
      }
      // a must be equal to b
      return 0;
    });
    
    boundsAddedItems.sort(function compareTops(a, b) {
      if (a.bounds.top < b.bounds.top) {
        return -1;
      }
      if (a.bounds.top > b.bounds.top) {
        return 1;
      }
      // a must be equal to b
      return 0;
    });

    if (wasEncapsulated) {
      return boundsAddedItems;
    } else {
      return unEncapsulateItems(boundsAddedItems);
    }
  }
}
